import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import './ComplaintSection.scss';

const ComplaintSection = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');

  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append('Žalba', data.Žalba);
      formData.append('_subject', 'Nova žalba sa ATT sajta');
      formData.append('_next', window.location.href);

      const response = await fetch(
        'https://formspree.io/f/xkgvvabd',
        {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        },
      );

      if (response.ok) {
        setMessage(
          t(
            'contact complaint successMessage',
            'Žalba uspješno poslana',
          ),
        );
        reset();
        setTimeout(() => setMessage(''), 5000);
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setMessage(
        t(
          'contact complaint errorMessage',
          'Greška pri slanju žalbe. Pokušajte ponovo.',
        ),
      );
      setTimeout(() => setMessage(''), 5000);
    }
  };

  return (
    <div className="complaint-section">
      <div className="complaint-container">
        <p className="complaint-text">
          {t(
            'contact complaint text',
            'U slučaju da želite da uložite žalbu na bilo koji aspekt poslovanja sa ATT možete to uraditi anonimno, tako što upišete vašu poruku ovdje.',
          )}
        </p>
        <form
          id="complaint-form"
          onSubmit={handleSubmit(onSubmit)}
          className="complaint-form"
        >
          <textarea
            rows="6"
            className="complaint-textarea"
            placeholder={t(
              'contact complaint placeholder',
              'Ovdje upišite svoju žalbu...',
            )}
            {...register('Žalba', {
              required: {
                value: true,
                message: t(
                  'contact complaint required',
                  'Molimo unesite vašu žalbu',
                ),
              },
              maxLength: 1000,
            })}
          />
          <div className="complaint-button-div">
            <p className="complaint-success-message">{message}</p>
            <button type="submit" className="complaint-btn">
              {t('contact complaint buttonText', 'Pošaljite žalbu')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ComplaintSection;
